import { OptimizationGroupSettingsPage } from '@/pages/optimization-group/settings'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
	'/_app/p/og/$optimizationGroupId/settings'
)({
	component: OptimizationGroupSettingsPage,
})
